export default __webpack_public_path__ + "static/media/failedImage.5d90744b.svg";